import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  inject,
} from '@angular/core';
import { ConfigService } from '../../shared/services/config.service';

@Component({
  selector: 'app-loading-circle',
  templateUrl: './loading-circle.component.html',
  styleUrls: ['./loading-circle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class LoadingCircleComponent {
  private cdr = inject(ChangeDetectorRef);

  oemId: string = ConfigService.getIdConfig();

  @Input() MIN_DISPLAY_TIME = 1500;

  private startTime: number;

  private _display = true;

  @Input() set display(value: boolean) {
    if (value == true) {
      this.startTime = new Date().getTime();
      this._display = true;
    } else {
      // if(this.startTime)
      const timeAfterStart = new Date().getTime() - this.startTime;

      if (isNaN(timeAfterStart) || timeAfterStart < 0)
        this.setDisplayAfterXSec(false, this.MIN_DISPLAY_TIME);
      else if (timeAfterStart > this.MIN_DISPLAY_TIME) this._display = false;
      else this.setDisplayAfterXSec(false, this.MIN_DISPLAY_TIME - timeAfterStart);

      this.cdr.detectChanges();
    }
  }

  setDisplayAfterXSec(value: boolean, delay: number) {
    setTimeout(() => {
      this._display = value;
      this.cdr.detectChanges();
    }, delay);
  }

  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  get display(): boolean {
    return this._display;
  }
}
